import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const isFor = ['Mujeres que sienten que la ansiedad les quita calidad de vida.', 'Personas que sufren de insomnio por pensamientos constantes.', 'Quienes buscan herramientas prácticas y rápidas, no solo teoría.', 'Cualquier persona que quiera entender y dominar su sistema nervioso.'];
const isNotFor = ['Personas que buscan una cura "mágica" sin aplicar las técnicas físicas.', 'Quienes no estén dispuestos a dedicar 2 minutos a practicar su respiración.', 'Personas que prefieren depender únicamente de fármacos sin explorar su capacidad de autorregulación.'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -15
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4
    }
  }
};
export function BenefitsSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-11">
      <div className="max-w-5xl mx-auto" data-id="element-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-13">
          {/* Who this IS for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-sage-light/50 rounded-3xl p-8 sm:p-10 border border-sage/20" data-id="element-14">
            <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brown mb-8" data-id="element-15">
              Esto es para ti si...
            </h2>

            <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true,
            margin: '-50px'
          }} className="space-y-5" data-id="element-16">
              {isFor.map((item, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-3" data-id="element-17">
                  <CheckCircleIcon className="w-6 h-6 text-sage flex-shrink-0 mt-0.5" data-id="element-18" />
                  <span className="text-brown-light text-lg leading-relaxed" data-id="element-19">
                    {item}
                  </span>
                </motion.li>)}
            </motion.ul>
          </motion.div>

          {/* Who this is NOT for */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="bg-cream rounded-3xl p-8 sm:p-10 border border-brown/5" data-id="element-20">
            <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brown mb-8" data-id="element-21">
              Esto NO es para ti si...
            </h2>

            <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
            once: true,
            margin: '-50px'
          }} className="space-y-5" data-id="element-22">
              {isNotFor.map((item, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-3" data-id="element-23">
                  <div className="w-6 h-6 rounded-full bg-brown/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-24">
                    <XIcon className="w-3.5 h-3.5 text-brown-light" data-id="element-25" />
                  </div>
                  <span className="text-brown-light text-lg leading-relaxed" data-id="element-26">
                    {item}
                  </span>
                </motion.li>)}
            </motion.ul>
          </motion.div>
        </div>
      </div>
    </section>;
}